<template>
    <section>
        <div class="row">
            <div class="col-12 col-sm-6 col-lg-4">
                <div class="field">
                    <label>ประเภทสินค้า</label>
                    <dropdown
                        v-model="formSearch.productCategory"
                        placeholder="-- ประเภทสินค้า --"
                        :options="option.productCategory"
                        :classes="{ input: 'input-field' }"
                    ></dropdown>
                </div>
            </div>
            <div class="col-12 col-sm-6 col-lg-4">
                <div class="field">
                    <label>รุ่น/ยี่ห้อสินค้า</label>
                    <input type="text" v-model="formSearch.keyword" class="input-field" placeholder="พิมพ์ชื่อรุ่น/ยี่ห้อ" />
                </div>
            </div>
            <div class="col-12 col-sm-6 col-lg-4">
                <div class="field">
                    <label>ช่วงราคา</label>
                    <div class="input-range">
                        <input type="tel"
                                v-model="formSearch.priceFrom"
                                class="input-field"
                                maxlength="5"
                                @keypress="$AppUtility.inputOnlyNumber($event)"
                                placeholder="จาก" />
                        <input type="tel"
                                v-model="formSearch.priceTo"
                                class="input-field"
                                maxlength="5"
                                @keypress="$AppUtility.inputOnlyNumber($event)"
                                placeholder="ถึง" />
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-sm-6 col-lg-4">
                <div class="field">
                    <label>สัปดาห์ยาง</label>
                    <div class="input-component-range">
                        <input-dot
                            v-model="formSearch.dotFrom"
                            class="input-component"
                            :inputClass="[ 'input-field' ]"
                            placeholder="จาก">
                        </input-dot>
                        <input-dot
                            v-model="formSearch.dotTo"
                            class="input-component"
                            :inputClass="[ 'input-field' ]"
                            placeholder="ถึง">
                        </input-dot>
                    </div>
                </div>
            </div>
            <div class="col-12 col-sm-6 col-lg-4">
                <div class="field">
                    <label>ขนาดยาง</label>
                    <div class="row input-tire-size">
                        <div class="col">
                            <dropdown
                                v-model="formSearch.tireSizeW"
                                placeholder="W"
                                :options="option.tireSizeW"
                                :classes="{ input: 'input-field' }"
                                @change="loadTireRatio($event)"
                            ></dropdown>
                        </div>
                        <div class="col">
                            <dropdown
                                v-model="formSearch.tireSizeR"
                                placeholder="R"
                                :options="option.tireSizeR"
                                :classes="{ input: 'input-field' }"
                                @change="loadTireDiameter($event)"
                            ></dropdown>
                        </div>
                        <div class="col">
                            <dropdown
                                v-model="formSearch.tireSizeD"
                                placeholder="D"
                                :options="option.tireSizeD"
                                :classes="{ input: 'input-field' }"
                            ></dropdown>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-sm-6 col-lg-4">
                <div class="field">
                    <label>ประเภทน้ำมันเครื่อง</label>
                    <dropdown
                        v-model="formSearch.engineOilType"
                        placeholder="ประเภทน้ำมันเครื่อง"
                        :options="option.engineOilType"
                        :classes="{ input: 'input-field' }"
                    ></dropdown>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-sm-6 col-lg-4">
                <div class="field">
                    <label>ยี่ห้อรถ</label>
                    <dropdown
                        v-model="formSearch.carBrand"
                        placeholder="ยี่ห้อรถ"
                        :options="option.carBrand"
                        :classes="{ input: 'input-field' }"
                        @change="loadCarModel($event)"
                    ></dropdown>
                </div>
            </div>
            <div class="col-12 col-sm-6 col-lg-4">
                <div class="field">
                    <label>รุ่นรถ</label>
                    <dropdown
                        v-model="formSearch.carModel"
                        placeholder="รุ่นรถ"
                        :options="option.carModel"
                        :classes="{ input: 'input-field' }"
                        @change="loadCarYearSerie($event)"
                    ></dropdown>
                </div>
            </div>
            <div class="col-12 col-sm-6 col-lg-4">
                <div class="field">
                    <label>ปีรถ</label>
                    <dropdown
                        v-model="formSearch.carYearSerie"
                        placeholder="ปีรถ"
                        :options="option.carYearSerie"
                        :classes="{ input: 'input-field' }"
                    ></dropdown>
                </div>
            </div>             
        </div>
        <div class="row">
            <div class="col-12">
                <div class="mt-3 text-center">
                    <button class="btn btn-secondary" @click="submitFilter()"><b-icon icon="search"></b-icon> ค้นหาสินค้า</button>
                    <button class="btn btn-outline-secondary" @click="resetForm()">ล้างข้อมูลค้นหา</button>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import OptionProductCategory from '@/database/staticOption/ProductCategory';
import OptionEngineOilType from '@/database/staticOption/EngineOilType';
import ModelStockFilter from '@/resources/models/StockFilter';

export default {
    data() {
        return {
            formSearch: this.initFormFilter(),
            option: {
                productCategory: [],
                tireSizeW: [],
                tireSizeR: [],
                tireSizeD: [],
                engineOilType: [],
                carBrand: [],
                carModel: [],
                carYearSerie: []
            }
        }
    },
    props: {
        isSmall: {
            type: Boolean,
            default: false
        }
    },
    mounted() {
        this.initOptionData();
    },
    methods: {
        resetForm() {
            this.formSearch = this.initFormFilter();
        },
        initFormFilter() {
            return ModelStockFilter.data();
        },
        async initOptionData() {
            this.option.productCategory = OptionProductCategory.option;

            this.option.tireSizeW = await this.$AppUtility.setupTireSizeWidthOption();
            this.option.tireSizeR = [];
            this.option.tireSizeD = [];

            this.option.engineOilType = OptionEngineOilType.option;

            this.option.carBrand = await this.$AppUtility.setupCarBrandOption();
            this.option.carModel = [];
            this.option.carYearSerie = [];
        },
        async loadTireRatio(value) {
            this.formSearch.tireSizeR = '';
            this.formSearch.tireSizeD = '';

            if (value) {
                const param = {
                    width: value
                };

                this.option.tireSizeR = await this.$AppUtility.setupTireSizeRatioOption(param);
            }
        },
        async loadTireDiameter(value) {
            this.formSearch.tireSizeD = '';

            if (value) {
                const param = { 
                    width: this.formSearch.tireSizeW,
                    ratio: value
                };

                this.option.tireSizeD = await this.$AppUtility.setupTireSizeDiameterOption(param);
            }
        },
        async loadCarModel(value) {
            if (value) {
                const param = {
                    carBrand: value
                };

                this.option.carModel = await this.$AppUtility.setupCarModelOption(param);
            } else {
                this.option.carModel = [];
                this.option.carYearSerie = [];
                this.formSearch.carModel = '';
                this.formSearch.carYearSerie = '';
            }
        },
        async loadCarYearSerie(value) {
            if (value) {
                const param = { 
                    carBrand: this.formSearch.carBrand,
                    carModel: value
                };

                this.option.carYearSerie = await this.$AppUtility.setupCarYearSerieOption(param);
            } else {
                this.option.carYearSerie = [];
                this.formSearch.carYearSerie = '';
            }
        },
        submitFilter() {
            this.$emit('lookup', this.formSearch);
        }
    }
}
</script>